import {
  Header,
  Paragraph
} from '@eggplant/pattern-library'

const MonitorCasePerformanceInfo = () =>
  <div className='grid gap-3'>
    <Header
      hasNoBottomMargin
      hasNoTopMargin
      rank={5}
    >
      Test case steps performance
    </Header>
    <Paragraph>
      The test case steps performance chart shows
      the runtime data of each test case steps in a
      run, allowing you to compare runs and observe trends.
    </Paragraph>
  </div>

export default MonitorCasePerformanceInfo
